import React, { useContext } from "react";

import { Views } from "~/actionItems/constants";
import Assignee from "~/actionItems/filters/Assignee";
import FilterToggles from "~/actionItems/filters/FilterToggles";
import GroupBy, { type GroupByType } from "~/actionItems/filters/GroupBy";
import Search from "~/actionItems/filters/Search";
import SortBy, { type SortByType } from "~/actionItems/filters/SortBy";
import { ActionItemsContext } from "~/actionItems/newActionItems/ActionItemsContext";
import type { AssigneeType } from "~/common/AssigneeFilter";

import styles from "./Filters.module.css";

export type FilterType = {
	groupBy: GroupByType;
	onChangeGroupBy(newGroupBy: GroupByType): void;
	sortBy: SortByType;
	onChangeSortBy(newSortBy: SortByType): void;
	showCompleted: boolean;
	onToggleShowCompleted(): void;
	showWontDo: boolean;
	onToggleShowWontDo(): void;
	showCreatedByYou: boolean;
	onToggleShowCreatedByYou(): void;
	showRecentOnly: boolean;
	onToggleShowRecentOnly(): void;
	showAIDetected: boolean;
	onToggleShowAIDetected(): void;
	hideAI: boolean;
	onToggleHideAI(): void;
	assignedTo?: AssigneeType[];
	onChangeAssignedTo(newAssignedTo?: AssigneeType[]): void;
	search: string;
	onChangeSearch(newSearch: string): void;
};

export default function Filters() {
	const { view } = useContext(ActionItemsContext);

	return (
		<div className={styles.filters} data-is-action-item-filters>
			<GroupBy />
			<SortBy />
			<FilterToggles />
			<div className={styles.alignRight}>
				{view === Views.TEAMMATES && <Assignee />}
				<Search />
			</div>
		</div>
	);
}
